import React, { useState, useEffect, useContext } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Card, CardBody } from "@windmill/react-ui";
import useParkingSubmit from "hooks/useParkingSubmit";
import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";
import InputArea from "components/form/InputName";
import InputAreaPrice from "components/form/InputAreaPrice";
import Error from "components/form/Error";
import DrawerButton from "components/form/DrawerButton";
import SelectSingleCityOnly from "components/form/SelectSingleCityOnly";
import { notifyError, notifySuccess } from "utils/toast";
import { SidebarContext } from "context/SidebarContext";
import axios from "axios";
import ParkingServices from "services/ParkingServices";
import DuplicateModal from "components/modal/DuplicateModel";
import Uploader from "components/image-uploader/Uploader";
import { FiX } from "react-icons/fi";
import InputDefault from "components/form/InputDefault";

const ParkingDrawer = ({ id, title }) => {
  const [vehicleUrl, setVehicleUrl] = useState("");
  const {
    register,
    handleSubmit,
    onSubmit,
    loading,
    errors,
    selectedCity,
    setSelectedCity,
    trigger
    
  } = useParkingSubmit(id, vehicleUrl, setVehicleUrl);


//console.log(selectedCity)
  const [categories, setCategories] = useState([]);
  const [checkingSightSeeing, setCheckingSightSeeing] = useState(false);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [duplicateData, setDuplicateData] = useState(null);

  const { setIsUpdate, toggleDrawer, isDrawerOpen, closeDrawer } =
    useContext(SidebarContext);

  const normalizeSightSeeing = (value) =>
    value.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();

  const handleCancelImage = (value) => {
    //console.log(value)
 //   console.log("clciked")
    if (value == "type") setVehicleUrl("");
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const allCategories = await ParkingServices.getAllCategories();
        // console.log("vehicle categories", allCategories);

        // Normalize id to number
        const normalizedCategories = allCategories.map((cat) => ({
          id: Number(cat.id),
          seats: cat.seats,
        }));

        // Dynamically group by seat count
        const collapsed = [
          {
            groupName: "Sedan",
            seats: normalizedCategories
              .filter((c) => c.seats >= 1 && c.seats <= 4)
              .map((c) => c.seats),
          },
          {
            groupName: "Suv & Muv",
            seats: normalizedCategories
              .filter((c) => c.seats > 4 && c.seats <= 8)
              .map((c) => c.seats),
          },
          {
            groupName: "Tempo Traveller",
            seats: normalizedCategories
              .filter((c) => c.seats > 8)
              .map((c) => c.seats),
          },
        ];

        setCategories(collapsed);
        // console.log("data grouped by seats", collapsed);
      } catch (err) {
        console.error("Failed to fetch vehicle categories:", err);
      }
    };

    fetchCategories();
  }, []);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title register={register} title="Edit Parking" />
        ) : (
          <Title register={register} title="Add Parking" />
        )}
      </div>

      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <Card className="flex-grow scrollbar-hide w-full max-h-full">
          <CardBody>
            <form
              onSubmit={handleSubmit(async (formData) => {
                if (!id && formData.sight_seeing && selectedCity) {
                  try {
                    const normalized = normalizeSightSeeing(
                      formData.sight_seeing
                    );

                    const res = await ParkingServices.checkSightSeeing(
                      selectedCity,
                      normalized
                    );

                    if (res?.message === "Sight Seeing already exists") {
                      // Save both formData and backend response
                      setDuplicateData({
                        normalized,
                        formData,
                        data: res.data, // contains id_parking, city_id, cost
                      });
                      setShowDuplicateModal(true);
                      return;
                    }
                  } catch (err) {
                    console.error("Sight Seeing check failed:", err);
                    notifyError("Failed to check Sight Seeing");
                    return;
                  }
                }
                //console.log(formData)
                onSubmit(formData, categories);
                
              })}
            >
              <div className="px-2 flex-grow scrollbar-hide w-full max-h-full pb-20">
                <div className="grid grid-cols-12 gap-6 items-center">
                  <div className="col-span-6">
                    <LabelArea required label="City Name" />
                    <SelectSingleCityOnly
                      register={register}
                      label="City Name"
                      name="city"
                      placeholder="--Choose City--"
                      selectedCity={selectedCity}
                      handleCityChange={setSelectedCity}
                    />
                    <Error errorName={errors.city} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label="Sight Seeing" />
                    <InputArea
                      register={register}
                      name="sight_seeing"
                      label="Sight Seeing"
                      type="text"
                      placeholder="Sight Seeing Place"
                    />
                    <Error errorName={errors.sight_seeing} />
                  </div>

<div className="col-span-6">
  <LabelArea required label="Timing" />
  <InputDefault
    register={register}
    trigger={trigger}
    name="timing"
    label="Timing"
    type="text"
    placeholder="Enter time range or note"
    required
  />
  <Error errorName={errors.timing} />
</div>

<div className="col-span-6">
  <LabelArea required label="Entry Fee" />
  <InputDefault
    register={register}
    trigger={trigger}
    name="entry"
    label="Entry Fee"
    type="text"
    placeholder="Enter entry fee amount or note"
    required
  />
  <Error errorName={errors.entry} />
</div>




                  {categories.length > 0 &&
                    categories.map((group, index) => (
                      <div
                        key={group.groupName || index}
                        className="col-span-6"
                      >
                        <LabelArea label={group.groupName} />
                        <InputDefault
                          register={register}
                          label={group.groupName}
                          name={`costs.${group.groupName}`}
                          type="text"
                          placeholder="Parking Amount"
                        />
                        <Error errorName={errors?.costs?.[group.groupName]} />
                      </div>
                    ))}

                  <div className="col-span-6">
                    <LabelArea label="Vehicle Image" />
                    {vehicleUrl ? (
                      <div className="flex items-center gap-2 relative">
                        <img
                          src={`${process.env.REACT_APP_API_IMAGE_URL}${vehicleUrl}`}
                          alt="caricon"
                          style={{
                            objectFit: "contain",
                            width: 100,
                            height: 100,
                          }}
                        />
                        <FiX
                          size={20}
                          className="cursor-pointer"
                          onClick={() => handleCancelImage("type")}
                        />
                      </div>
                    ) : (
                      <Uploader
                        is_multiple={true}
                        folder="carparking"
                        name_merge="Type"
                        imageUrl={vehicleUrl}
                        acceptType="image/png"
                        setImageUrl={setVehicleUrl}
                        no_of_image={1}
                      />
                    )}
                  </div>
                </div>
              </div>

              <DrawerButton
                isSubmitting={loading}
                id={id}
                title={id ? "Update" : "Save"}
              />
            </form>
          </CardBody>
        </Card>
      </Scrollbars>

      <DuplicateModal
        show={showDuplicateModal}
        onHide={() => setShowDuplicateModal(false)}
        onSkip={() => {
          setShowDuplicateModal(false);
          closeDrawer();
        }}
        onUpdate={async () => {
          try {
            // Transform costs into { categoryId: number }
            const transformedCost = {};
            categories.forEach((group) => {
              const value =
                Number(duplicateData.formData.costs?.[group.groupName]) || 0;
              transformedCost[group.groupName] = value;
            });
            // console.log("transformed cost", transformedCost);

            // Prepare payload
            const payload = {
              city_id: selectedCity,
              sight_seeing: duplicateData.formData.sight_seeing,
              cost: transformedCost,
              timing: duplicateData.formData.timing || null,
              entry: duplicateData.formData.entry || null,
              image: duplicateData.formData.image || null,
            };

            // Use existing parking id from backend response
            await ParkingServices.updateParking(
              duplicateData.data.id_parking,
              payload
            );

            notifySuccess("Updated successfully");
            setIsUpdate(true);
            toggleDrawer();
          } catch (err) {
            console.error("Update failed:", err);
            notifyError("Failed to update");
          } finally {
            setShowDuplicateModal(false);
          }
        }}
      />
    </>
  );
};

export default ParkingDrawer;
